import React from "react"
import { Text, View, StyleSheet } from "@react-pdf/renderer"
import { MapIconPDF } from "./icons/Map"
import { BriefCaseIconPDF } from "./icons/BriefCase"
import { DollarSignIconPDF } from "./icons/DollarSign"

const styles = StyleSheet.create({
	summaryTitle: {
		fontSize: 12,
		fontWeight: "bold",
		marginBottom: 16,
		marginLeft: 16,
	},
	summaryGrid: {
		flexDirection: "row",
		backgroundColor: "white",
		gap: 16,
	},
	summaryItem: {
		borderRadius: 8,
		border: "1px solid #dadada",
		paddingHorizontal: 24,
		paddingVertical: 16,
		borderLeftWidth: 1,
		borderLeftColor: "#dadada",
	},
	summaryItemIcon: {
		marginLeft: 48,
	},
	summaryItemTop: {
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: 2,
	},
	summaryItemLabel: {
		fontSize: 10,
		color: "black",
	},
	summaryItemValue: {
		fontSize: 20,
		fontWeight: "bold",
	},
})

interface ReportSummaryProps {
	summary: {
		businessValue: string
		totalDistance: string
		totalDrives: string
	}
}

export const ReportSummaryPDF: React.FC<ReportSummaryProps> = ({ summary }) => {
	return (
		<>			
			<View style={styles.summaryGrid}>
				<View style={styles.summaryItem}>
					<View style={styles.summaryItemTop}>
						<Text style={styles.summaryItemLabel}>Total Mileage</Text>
						<View style={styles.summaryItemIcon}>
							<MapIconPDF />
						</View>
					</View>
					<Text style={styles.summaryItemValue}>{summary.totalDistance}</Text>
				</View>
				<View style={[styles.summaryItem]}>
					<View style={styles.summaryItemTop}>
						<Text style={styles.summaryItemLabel}>Business Trips</Text>
						<View style={styles.summaryItemIcon}>
							<BriefCaseIconPDF />
						</View>
					</View>
					<Text style={styles.summaryItemValue}>{summary.totalDrives}</Text>
				</View>
				<View style={styles.summaryItem}>
					<View style={styles.summaryItemTop}>
						<Text style={styles.summaryItemLabel}>Business Value</Text>
						<View style={styles.summaryItemIcon}>
							<DollarSignIconPDF width={16} height={16} stroke="#81838b" />
						</View>
					</View>
					<Text style={styles.summaryItemValue}>{summary.businessValue}</Text>
				</View>
			</View>
		</>
	)
}
